/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupSalesRoutingModule } from './builder-setup-sales-routing.module';
import { ChecklistListTabComponent } from './components/checklist-tab/checklist-tab.component';
import { CommunityListTabComponent } from './components/community-list-tab/community-list-tab.component';
import { ImportLeadsTabComponent } from './components/import-leads-tab/import-leads-tab.component';
import { SalesTabContainerComponent } from './components/sales-tab-container/sales-tab-container.component';
import { ChecklistListBusinessService } from './resources/checklist-business.service';
import { CommunityListBusinessService } from './resources/community-list-business.service';
import { ImportLeadsTabBusinessService } from './resources/import-leads-tab-business.service';

@NgModule({
  imports: [
    DragDropModule,
    BuilderSharedModule.forChild(),
    BuilderSetupSalesRoutingModule,
  ],
  providers: [
    CommunityListBusinessService,
    ChecklistListBusinessService,
    ImportLeadsTabBusinessService,
  ],
  declarations: [
    SalesTabContainerComponent,
    CommunityListTabComponent,
    ChecklistListTabComponent,
    ImportLeadsTabComponent,
  ],
})
export class BuilderSetupSalesModule {
}
